import { useState } from "react";
import { Search } from "lucide-react";
import { usd, fmtDate, TXN_LABELS } from "@/lib/api";
import { useFetch, PageHeader, Panel, StatusBadge, Table, Empty, Loading } from "@/components/common";

export default function AdminTransactions() {
  const [type, setType] = useState("");
  const [q, setQ] = useState("");
  const [search, setSearch] = useState("");
  const { data, loading } = useFetch(`/admin/transactions?type=${type}&search=${encodeURIComponent(search)}`);
  const total = (data || []).reduce((s, t) => s + (t.status === "completed" ? t.amount : 0), 0);
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Admin" title="All transactions" subtitle="Full platform ledger, including welcome bonus records." />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex gap-2">
          <select className="nx-input w-52" value={type} onChange={(e) => setType(e.target.value)} data-testid="admin-txn-type-filter">
            <option value="">All types</option>
            {Object.entries(TXN_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <form onSubmit={(e) => { e.preventDefault(); setSearch(q); }} className="relative">
            <Search size={15} className="absolute left-3 top-3 text-slate-500" />
            <input className="nx-input w-64 pl-9" placeholder="User ID, email or description" value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-txn-search-input" />
          </form>
        </div>
        {type && <p className="text-sm text-slate-400" data-testid="admin-txn-total">Completed total: <span className="num text-[#10B981]">{usd(total)}</span> · {data?.length || 0} records</p>}
      </div>
      <Panel>
        {loading ? <Loading /> : (
          <Table head={["Date", "User ID", "Email", "Type", "Description", "Amount", "Currency", "Status"]} testid="admin-transactions-table">
            {!data?.length && <Empty cols={8} text="No transactions" />}
            {data?.map((t) => (
              <tr key={t.id}>
                <td className="nx-td text-xs">{fmtDate(t.created_at)}</td>
                <td className="nx-td num text-[#10B981]">{t.user?.user_code}</td>
                <td className="nx-td text-xs">{t.user?.email}</td>
                <td className="nx-td">{TXN_LABELS[t.type] || t.type}</td>
                <td className="nx-td text-white">{t.description}</td>
                <td className="nx-td num">{t.direction === "debit" ? "−" : t.direction === "credit" ? "+" : ""}{usd(t.amount)}</td>
                <td className="nx-td">{t.currency}</td>
                <td className="nx-td"><StatusBadge status={t.status} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
